import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            padding: 3,
            margin: '0px 1px 20px',

        },
        sectionList: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            position: 'relative',
            gap: 3,
            /* zIndex: 10, */
            boxShadow: `0px -1px ${colors.color25}`
            // marginTop: '50px'
        },
        tag: {
            background: colors.color5,
            position: 'relative',
            /* zIndex: 100, */
            marginTop: '50px',
            marginLeft: '1px',
            left: '0',
            width: '200px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '50px',
            boxShadow: `-1px 0px ${colors.color25}, 1px 0px ${colors.color25},0px -1px ${colors.color25}`,
            '& .MuiTypography-root': {
                color: colors.primary,
                fontWeight: 'bold',
                fontSize: '14px'
            }
        }
    }
}

export { useStyles }
